import { LitElement, TemplateResult, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { AdoptedStyleSheets } from '../../controllers/adopted-stylesheets';
import innerCSS from './se-container.inner.pcss?inline';

/**
 * The SeContainer component
 * @element se-container
 * @slot - default
 */
@customElement('se-container')
export class SeContainer extends LitElement {
  private stylesheetController = new AdoptedStyleSheets(this, {
    encapsulatedCSS: innerCSS,
  });

  /**
   * The vertical space from the component above it (using Utopia fluid space
   * variables defined in outline.theme.css, ie. space-3xl)
   **/
  @property({
    type: String,
    reflect: true,
    attribute: 'top-margin',
  })
  topMargin: string;

  @property({
    type: Boolean,
    reflect: true,
    attribute: 'justify-end',
  })
  justifyEnd = false;

  @property({
    type: String,
    reflect: true,
    attribute: 'variant',
  })
  variant: string;

  updated(): void {
    if (this.variant === 'narrow') {
      this.style.setProperty('--container-max-content-width', '900px');
    } else {
      this.style.removeProperty('--container-max-content-width');
    }
    if (this.topMargin) {
      this.style.marginTop = `var(--${this.topMargin})`;
    } else {
      this.style.marginTop = '';
    }
    if (this.justifyEnd) {
      this.style.justifyContent = 'flex-end';
    } else {
      this.style.removeProperty('justify-content');
    }
  }

  render(): TemplateResult {
    return html`<slot></slot>`;
  }
}
